import { render, staticRenderFns } from "./JTreeTable.vue?vue&type=template&id=2c1fb6a5&scoped=true"
import script from "./JTreeTable.vue?vue&type=script&lang=js"
export * from "./JTreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fb6a5",
  null
  
)

export default component.exports